var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("pdf-preview", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.inPreview,
            expression: "inPreview"
          }
        ],
        attrs: {
          inPreview: _vm.inPreview,
          generatingPreview: _vm.generatingPreview,
          saving: _vm.saving,
          pdfUrl: _vm.pdfUrl,
          backToForm: _vm.backToForm,
          save: _vm.save
        }
      }),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.inPreview,
              expression: "!inPreview"
            }
          ]
        },
        [
          _c(
            "form",
            {
              staticClass: "mb-5",
              attrs: { autocomplete: "off" },
              on: {
                submit: function($event) {
                  $event.preventDefault()
                }
              }
            },
            [
              _c("h2", [_vm._v(" RESOLUCIÓN EXENTA ")]),
              _c("div", { staticClass: "row" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "fullName" } }, [
                          _vm._v(" Unidad "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.required("unitUser"))
                            }
                          })
                        ]),
                        _c("list-user-groups", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "groupStep",
                          staticClass: "w-100",
                          attrs: {
                            autocomplete: "",
                            label: "",
                            name: "unitUser",
                            "data-vv-as": "unidad",
                            "data-cy": "unit-user",
                            danger: _vm.errors.has("unitUser"),
                            "danger-text": _vm.errors.first("unitUser")
                          },
                          on: {
                            "full-group": function($event) {
                              _vm.formData.unitUserLabel = $event.label
                            }
                          },
                          model: {
                            value: _vm.formData.unitUser,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "unitUser", $$v)
                            },
                            expression: "formData.unitUser"
                          }
                        }),
                        _vm.$validator.errors.has("unitUser")
                          ? _c("b-form-invalid-feedback", [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$validator.errors.first("unitUser")
                                  ) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 mb-3 mt-3" },
                  [
                    _c("b-form-group", [
                      _c(
                        "div",
                        { staticClass: "row" },
                        [
                          _c("label", { attrs: { for: "office" } }, [
                            _vm._v(" Sucursal "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.required("office"))
                              }
                            })
                          ]),
                          _c(
                            "b-form-radio-group",
                            {
                              directives: [
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required",
                                  expression: "'required'"
                                }
                              ],
                              staticClass: "col-4",
                              attrs: {
                                "data-cy": "office",
                                name: "office",
                                "data-vv-as": "sucursal",
                                state: _vm.$validator.errors.has("office")
                                  ? false
                                  : null,
                                danger: _vm.$validator.errors.has("office"),
                                "danger-text": _vm.$validator.errors.first(
                                  "office"
                                )
                              },
                              model: {
                                value: _vm.formData.office,
                                callback: function($$v) {
                                  _vm.$set(_vm.formData, "office", $$v)
                                },
                                expression: "formData.office"
                              }
                            },
                            [
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "ml-3 mr-5",
                                  attrs: { value: "Santiago" }
                                },
                                [_vm._v("Santiago")]
                              ),
                              _c(
                                "b-form-radio",
                                {
                                  staticClass: "ml-3 mr-5",
                                  attrs: { value: "Peñaflor" }
                                },
                                [_vm._v("Peñaflor")]
                              )
                            ],
                            1
                          ),
                          _vm.$validator.errors.has("office")
                            ? _c("b-form-invalid-feedback", [
                                _vm._v(
                                  " " +
                                    _vm._s(
                                      _vm.$validator.errors.first("office")
                                    ) +
                                    " "
                                )
                              ])
                            : _vm._e()
                        ],
                        1
                      )
                    ])
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-6" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "birthDate" } }, [
                          _vm._v(" Fecha "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.required("date"))
                            }
                          })
                        ]),
                        _c("date-picker", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          class: {
                            "w-100": true,
                            danger: _vm.$validator.errors.has("date")
                          },
                          attrs: {
                            "data-cy": "date",
                            name: "date",
                            "data-vv-as": "fecha",
                            format: "YYYY-MM-DD",
                            disabled: "",
                            "value-type": "YYYY-MM-DD",
                            danger: _vm.$validator.errors.has("date")
                          },
                          model: {
                            value: _vm.formData.date,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "date", $$v)
                            },
                            expression: "formData.date"
                          }
                        }),
                        _vm.$validator.errors.has("date")
                          ? _c("v-invalid-feedback", [
                              _vm._v(
                                " " +
                                  _vm._s(_vm.$validator.errors.first("date")) +
                                  " "
                              )
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "matter" } }, [
                          _vm._v(" Materia "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.required("matter"))
                            }
                          })
                        ]),
                        _vm._l(_vm.formData.matter, function(matter, index) {
                          return _c(
                            "div",
                            { key: "matter-" + index, staticClass: "row" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-9 mt-3" },
                                [
                                  _c("b-form-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min: 1",
                                        expression: "'required|min: 1'"
                                      }
                                    ],
                                    attrs: {
                                      rows: "2",
                                      "data-cy": "matter",
                                      name: "matter",
                                      "data-vv-as": "materia",
                                      placeholder: "Ingrese la materia...",
                                      state: _vm.$validator.errors.has("matter")
                                        ? false
                                        : null,
                                      danger: _vm.$validator.errors.has(
                                        "matter"
                                      ),
                                      "danger-text": _vm.$validator.errors.first(
                                        "matter"
                                      )
                                    },
                                    model: {
                                      value: matter.text,
                                      callback: function($$v) {
                                        _vm.$set(matter, "text", $$v)
                                      },
                                      expression: "matter.text"
                                    }
                                  }),
                                  _vm.$validator.errors.has("matter")
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(" Ingresa al menos una materia ")
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("div", { staticClass: "col-md-3 mt-6" }, [
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        attrs: {
                                          color: "danger",
                                          type: "border",
                                          icon: "delete"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeMatter(index)
                                          }
                                        }
                                      },
                                      [_vm._v(" Eliminar fila ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        _c(
                          "div",
                          { staticClass: "text-right mt-5" },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  icon: "add"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.addMatterItem()
                                  }
                                }
                              },
                              [_vm._v(" Agregar materia ")]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "views" } }, [
                          _vm._v(" Vistos "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.required("views"))
                            }
                          })
                        ]),
                        _vm._l(_vm.formData.views, function(view, index) {
                          return _c(
                            "div",
                            { key: "view-" + index, staticClass: "row" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-9 mt-3" },
                                [
                                  _c("b-form-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min: 1",
                                        expression: "'required|min: 1'"
                                      }
                                    ],
                                    attrs: {
                                      rows: "2",
                                      "data-cy": "view",
                                      name: "view",
                                      "data-vv-as": "vistos",
                                      placeholder: "Ingrese el visto...",
                                      state: _vm.$validator.errors.has("view")
                                        ? false
                                        : null,
                                      danger: _vm.$validator.errors.has("view"),
                                      "danger-text": _vm.$validator.errors.first(
                                        "view"
                                      )
                                    },
                                    model: {
                                      value: view.text,
                                      callback: function($$v) {
                                        _vm.$set(view, "text", $$v)
                                      },
                                      expression: "view.text"
                                    }
                                  }),
                                  _vm.$validator.errors.has("view")
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(" Ingresa al menos un visto ")
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("div", { staticClass: "col-md-3 mt-6" }, [
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        attrs: {
                                          color: "danger",
                                          type: "border",
                                          icon: "delete"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeView(index)
                                          }
                                        }
                                      },
                                      [_vm._v(" Eliminar fila ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        _c(
                          "div",
                          { staticClass: "text-right mt-5" },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  icon: "add"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.addViewsItem()
                                  }
                                }
                              },
                              [_vm._v(" Agregar visto ")]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c(
                      "b-form-group",
                      [
                        _c("label", { attrs: { for: "considering" } }, [
                          _vm._v(" Considerando "),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(_vm.required("considering"))
                            }
                          })
                        ]),
                        _vm._l(_vm.formData.considering, function(
                          considering,
                          index
                        ) {
                          return _c(
                            "div",
                            { key: "considering-" + index, staticClass: "row" },
                            [
                              _c(
                                "div",
                                { staticClass: "col-md-9 mt-3" },
                                [
                                  _c("b-form-textarea", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|min: 1",
                                        expression: "'required|min: 1'"
                                      }
                                    ],
                                    attrs: {
                                      rows: "2",
                                      "data-cy": "considering",
                                      name: "considering",
                                      "data-vv-as": "considerando",
                                      placeholder: "Ingrese el texto...",
                                      state: _vm.$validator.errors.has(
                                        "considering"
                                      )
                                        ? false
                                        : null,
                                      danger: _vm.$validator.errors.has(
                                        "considering"
                                      ),
                                      "danger-text": _vm.$validator.errors.first(
                                        "considering"
                                      )
                                    },
                                    model: {
                                      value: considering.text,
                                      callback: function($$v) {
                                        _vm.$set(considering, "text", $$v)
                                      },
                                      expression: "considering.text"
                                    }
                                  }),
                                  _vm.$validator.errors.has("considering")
                                    ? _c("b-form-invalid-feedback", [
                                        _vm._v(
                                          " Ingresa al menos una elemento "
                                        )
                                      ])
                                    : _vm._e()
                                ],
                                1
                              ),
                              _c("div", { staticClass: "col-md-3 mt-6" }, [
                                _c(
                                  "div",
                                  { staticClass: "text-center" },
                                  [
                                    _c(
                                      "vs-button",
                                      {
                                        attrs: {
                                          color: "danger",
                                          type: "border",
                                          icon: "delete"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.removeConsidering(index)
                                          }
                                        }
                                      },
                                      [_vm._v(" Eliminar fila ")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        _c(
                          "div",
                          { staticClass: "text-right mt-5" },
                          [
                            _c(
                              "vs-button",
                              {
                                staticClass: "w-100",
                                attrs: {
                                  color: "primary",
                                  type: "border",
                                  icon: "add"
                                },
                                on: {
                                  click: function($event) {
                                    return _vm.addConsidereItem()
                                  }
                                }
                              },
                              [_vm._v(" Agregar considerando ")]
                            )
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Establece *" } },
                      [
                        _c("editor-text", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "stablishment",
                          attrs: {
                            danger: _vm.errors.has("stablishment"),
                            "danger-text": _vm.errors.first("stablishment"),
                            "data-cy": "stablishment",
                            "data-vv-as": "establece",
                            "max-length": 8000,
                            name: "stablishment",
                            toolbarItems: {
                              items: [
                                "undo",
                                "redo",
                                "|",
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "|",
                                "insertTable",
                                "|",
                                "numberedList",
                                "bulletedList"
                              ]
                            },
                            "with-counter": ""
                          },
                          model: {
                            value: _vm.formData.stablishment,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "stablishment", $$v)
                            },
                            expression: "formData.stablishment"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Déjese *" } },
                      [
                        _c("editor-text", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "leave",
                          attrs: {
                            danger: _vm.errors.has("leave"),
                            "danger-text": _vm.errors.first("leave"),
                            "data-cy": "leave",
                            "data-vv-as": "déjese",
                            "max-length": 8000,
                            name: "leave",
                            toolbarItems: {
                              items: [
                                "undo",
                                "redo",
                                "|",
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "|",
                                "insertTable",
                                "|",
                                "numberedList",
                                "bulletedList"
                              ]
                            },
                            "with-counter": ""
                          },
                          model: {
                            value: _vm.formData.leave,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "leave", $$v)
                            },
                            expression: "formData.leave"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-md-12" },
                  [
                    _c(
                      "b-form-group",
                      { attrs: { label: "Comuníquese *" } },
                      [
                        _c("editor-text", {
                          directives: [
                            {
                              name: "validate",
                              rawName: "v-validate",
                              value: "required",
                              expression: "'required'"
                            }
                          ],
                          ref: "communicate",
                          attrs: {
                            danger: _vm.errors.has("communicate"),
                            "danger-text": _vm.errors.first("communicate"),
                            "data-cy": "communicate",
                            "data-vv-as": "comuníquese",
                            "max-length": 8000,
                            name: "communicate",
                            toolbarItems: {
                              items: [
                                "undo",
                                "redo",
                                "|",
                                "heading",
                                "|",
                                "bold",
                                "italic",
                                "|",
                                "insertTable",
                                "|",
                                "numberedList",
                                "bulletedList"
                              ]
                            },
                            "with-counter": ""
                          },
                          model: {
                            value: _vm.formData.communicate,
                            callback: function($$v) {
                              _vm.$set(_vm.formData, "communicate", $$v)
                            },
                            expression: "formData.communicate"
                          }
                        })
                      ],
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", { attrs: { for: "MOC" } }, [_vm._v("MOC")]),
                    _c("b-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required",
                          expression: "'required'"
                        }
                      ],
                      attrs: {
                        name: "user",
                        placeholder: "MOC",
                        "data-vv-as": "user",
                        "data-cy": "user",
                        disabled: "",
                        danger: _vm.$validator.errors.has("user"),
                        "danger-text": _vm.$validator.errors.first("user"),
                        state: _vm.$validator.errors.has("user") ? false : null
                      },
                      model: {
                        value: _vm.formData.user,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "user", $$v)
                        },
                        expression: "formData.user"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("label", { attrs: { for: "numberProcess" } }, [
                      _vm._v("N° proceso")
                    ]),
                    _c("span", {
                      domProps: {
                        innerHTML: _vm._s(_vm.required("numberProcess"))
                      }
                    }),
                    _c("b-input", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: "required|max:10",
                          expression: "'required|max:10'"
                        }
                      ],
                      attrs: {
                        name: "numberProcess",
                        placeholder: "N° proceso",
                        "data-vv-as": "nro. proceso",
                        "data-cy": "numberProcess",
                        danger: _vm.$validator.errors.has("numberProcess"),
                        "danger-text": _vm.$validator.errors.first(
                          "numberProcess"
                        ),
                        state: _vm.$validator.errors.has("numberProcess")
                          ? false
                          : null
                      },
                      model: {
                        value: _vm.formData.numberProcess,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "numberProcess", $$v)
                        },
                        expression: "formData.numberProcess"
                      }
                    }),
                    _vm.$validator.errors.has("numberProcess")
                      ? _c("b-form-invalid-feedback", [
                          _vm._v(
                            " " +
                              _vm._s(
                                _vm.$validator.errors.first("numberProcess")
                              ) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 mt-2" },
                  [
                    _c("label", { attrs: { for: "director" } }, [
                      _vm._v("Director Ejecutivo")
                    ]),
                    _c("span", {
                      domProps: { innerHTML: _vm._s(_vm.required("director")) }
                    }),
                    _c("select-options", {
                      directives: [
                        {
                          name: "validate",
                          rawName: "v-validate",
                          value: { required: !_vm.formData.alternate },
                          expression: "{required: !formData.alternate }"
                        }
                      ],
                      attrs: {
                        "options-group": "res-director",
                        "alphabetical-sort": true,
                        name: "director",
                        placeholder: "",
                        "data-vv-as": "director",
                        "data-cy": "director",
                        "select-first": "",
                        danger: _vm.$validator.errors.has("director"),
                        "danger-text": _vm.$validator.errors.first("director"),
                        state: _vm.$validator.errors.has("director")
                          ? false
                          : null
                      },
                      on: {
                        input: function($event) {
                          _vm.formData.alternate = ""
                        }
                      },
                      model: {
                        value: _vm.formData.director,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "director", $$v)
                        },
                        expression: "formData.director"
                      }
                    }),
                    _vm.$validator.errors.has("director")
                      ? _c("v-invalid-feedback", [
                          _vm._v(
                            " " +
                              _vm._s(_vm.$validator.errors.first("director")) +
                              " "
                          )
                        ])
                      : _vm._e()
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-6 mt-2" },
                  [
                    _c("label", { attrs: { for: "alternate" } }, [
                      _vm._v("Suplente")
                    ]),
                    _c("select-options", {
                      attrs: {
                        "options-group": "res-alternate",
                        "alphabetical-sort": true,
                        name: "alternate",
                        placeholder: "",
                        "data-vv-as": "suplente",
                        "data-cy": "alternate",
                        danger: _vm.$validator.errors.has("alternate"),
                        "danger-text": _vm.$validator.errors.first("alternate"),
                        state: _vm.$validator.errors.has("alternate")
                          ? false
                          : null
                      },
                      on: {
                        input: function($event) {
                          _vm.formData.director = ""
                        }
                      },
                      model: {
                        value: _vm.formData.alternate,
                        callback: function($$v) {
                          _vm.$set(_vm.formData, "alternate", $$v)
                        },
                        expression: "formData.alternate"
                      }
                    })
                  ],
                  1
                )
              ])
            ]
          ),
          _c("form-action-buttons", {
            attrs: {
              saving: _vm.saving,
              preview: _vm.preview,
              back: _vm.back,
              save: _vm.save
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }